import {INotificationTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategy'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {IBrowserNotification} from '@toolify/client/src/stores/NotificationStore/types/IBrowserNotification'
import {getNotificationSoundUrl} from '@toolify/client/src/stores/NotificationStore/functions/getNotificationSoundUrl'
import {DefaultNotificationStrategy} from './DefaultNotificationStrategy'

export class AppVersionPublishedNotificationStrategy extends DefaultNotificationStrategy<NotificationType.AppVersionPublished> implements INotificationTypeStrategy {
  getBrowserNotification(notification: INotificationResponseInstance<NotificationType.AppVersionPublished>, authorNick: string): IBrowserNotification {
    const {appName, appItemName, version} = notification.payload
    const title = 'New app version published'
    const body = `${authorNick} published ${appName} · ${appItemName} (v${version})`
    const sound = getNotificationSoundUrl('new-notification.wav')
    return {
      sound,
      title,
      body,
    }
  }
}
